export var KPI;
(function (KPI) {
    KPI["GPR"] = "GPR";
    KPI["BPR"] = "BPR";
    KPI["GCR"] = "GCR";
    KPI["GPR_BY_GCR"] = "GPR_BY_GCR";
})(KPI || (KPI = {}));
;
export var PSAO;
(function (PSAO) {
    PSAO["APCI"] = "APCI";
    PSAO["AAP"] = "AAP";
    PSAO["AAPA"] = "AAPA";
    PSAO["APSC"] = "APSC";
    PSAO["EPIC"] = "EPIC";
    PSAO["CARE"] = "CARE";
    PSAO["IPC"] = "IPC";
    PSAO["NPSC"] = "NPSC";
    PSAO["CPA"] = "CPA";
    PSAO["Smart_Fill"] = "Smart Fill";
    PSAO["APRX"] = "APRX";
    PSAO["Aspire"] = "Aspire";
    PSAO["IPB"] = "IPB";
    PSAO["IPA"] = "IPA";
    PSAO["PharmaGroup"] = "PharmaGroup";
    PSAO["Nexus_Pharmacy_Alliance"] = "Nexus Pharmacy Alliance";
    PSAO["Sav_Mor"] = "Sav-Mor";
    PSAO["Montana_Family_Pharmacies"] = "Montana Family Pharmacies";
    PSAO["WSPC"] = "WSPC";
    PSAO["MHA"] = "MHA";
    PSAO["TPG"] = "TPG";
    PSAO["OTHER"] = "Other";
})(PSAO || (PSAO = {}));
;
;
/**
 * Evaluation cadence of a GCR tier matrix. IPC USave has quarterly generic/brand
 * matrices plus an additive monthly brand-rebate matrix (PM-1434). Absent on
 * docs that predate this field — treat undefined as quarterly.
 */
export var RebateCadence;
(function (RebateCadence) {
    RebateCadence["QUARTERLY"] = "quarterly";
    RebateCadence["MONTHLY"] = "monthly";
})(RebateCadence || (RebateCadence = {}));
;
/**
 * How the `rebate` value is denominated. IPC USave generic tiers pay $ per unit;
 * the Mid Market Unaffiliated merchandise rebate is a flat not-to-exceed $ amount.
 */
export var RebateUnit;
(function (RebateUnit) {
    RebateUnit["PERCENT"] = "percent";
    RebateUnit["DOLLARS_PER_UNIT"] = "dollarsPerUnit";
    RebateUnit["DOLLARS"] = "dollars";
})(RebateUnit || (RebateUnit = {}));
;
/**
 * Which Scrubbed-GCR rebate structure a Mid Market Unaffiliated tier belongs to
 * (PM-1495). The deal has four structures driven by the same shared GCR metric
 * but with different thresholds and outputs; this discriminates them since cadence
 * + isGenericRebate alone can't (three are monthly brand structures).
 */
export var RebateStructure;
(function (RebateStructure) {
    RebateStructure["BRAND_RX_COGS"] = "brandRxCogs";
    RebateStructure["MONTHLY_BRAND_REBATE"] = "monthlyBrandRebate";
    RebateStructure["MERCHANDISE_REBATE"] = "merchandiseRebate";
    RebateStructure["ONESTOP_REBATE"] = "oneStopRebate";
})(RebateStructure || (RebateStructure = {}));
;
;
